import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { useTranslations } from '../i18n';

export function ExportButton() {
    const t = useTranslations();
    return <div
        onClick={() => {
            window.location.hash = "/export";
        }}
        className="icon-button"
        title={t.exportAsImageButtonTitle}
    >
        <FontAwesomeIcon icon={faImage} />
    </div>;
}
